// Enter-to-send for chat composers (BL-1486). Enter submits the enclosing
// form; Shift+Enter keeps its default and inserts a newline. An IME
// composition's Enter (committing a character) is left alone.

import type { KeyboardEvent } from 'react';

/**
 * Keydown handler for a chat-style `<textarea>`: plain Enter requests the
 * enclosing form's submit, Shift+Enter inserts a newline.
 *
 * Uses `form.requestSubmit()` rather than `submit()` so the form's own
 * `onSubmit` (RHF's `handleSubmit`) runs exactly as a Send click would.
 *
 * @param event - the textarea keydown event.
 */
export function submitOnEnter(event: KeyboardEvent<HTMLTextAreaElement>): void {
    if (event.key !== 'Enter' || event.shiftKey || event.nativeEvent.isComposing) return;
    event.preventDefault();
    event.currentTarget.form?.requestSubmit();
}
